module.exports = __webpack_public_path__ + "static/Bhutan-logo-5432a90b55c6112f16ac72aae0d02be7.png";